// src/ViewGames.js
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const ViewGames = () => {
  const [games, setGames] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchGames = async () => {
      try {
        const response = await fetch("https://teamo.co.za/api/games");
        const data = await response.json();
        setGames(data);
      } catch (error) {
        console.error("Error fetching games:", error);
      }
    };
    fetchGames();
  }, []);

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h1>Available Games</h1>
      <button
        onClick={() => navigate("/")}
        style={{ marginBottom: "20px", padding: "10px 20px" }}
      >
        Back to Home
      </button>
      <div>
        {games.length === 0 ? (
          <p>No games available</p>
        ) : (
          <ul>
            {games.map((game) => (
              <li key={game.id}>
                {game.game_date} at {game.game_time} - {game.venue} against {game.opponent}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default ViewGames;
